import { render } from "./NewHomePage.vue?vue&type=template&id=753c2d80&scoped=true"
import script from "./NewHomePage.vue?vue&type=script&lang=js"
export * from "./NewHomePage.vue?vue&type=script&lang=js"

import "./NewHomePage.vue?vue&type=style&index=0&id=753c2d80&scoped=true&lang=css"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753c2d80"]])

export default __exports__